export interface UpdateFacilityPositionDto {
  name: string; // Required, max 100 characters
  abbreviation: string; // Required, max 10 characters
  description?: string | null; // Optional, max 500 characters
  isActive: boolean; // Required
}
